import { render } from "./IncidentForm.vue?vue&type=template&id=4a636eb1"
import script from "./IncidentForm.vue?vue&type=script&lang=js"
export * from "./IncidentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__